import { checkTgApp, expandTgApp } from 'lotto-shared';
import { FC, PropsWithChildren, useEffect } from 'react';

const useTgApp = () => {
  useEffect(() => {
    checkTgApp();
    expandTgApp();
  }, []);
};

export const TgApp: FC<PropsWithChildren> = ({ children }) => {
  useTgApp();
  return <>{children}</>;
};
